import { pathOr } from 'ramda';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import type { ChatTask } from '@frontend/api';

import { entitiesStore } from 'modules/common/chat/entities/actions';

import partLibraryService from 'services/partLibraryService';

import type { ActionOfType } from 'store/types';

import { editTask, types, type ChatTasksAction } from './actions';
import { getTaskAssignmentDueDate, getTaskAssignmentUserId } from './reducer';

export default function* root() {
  yield takeEvery(types.EDIT_TASK_REQUEST, watchUpdateTask);
}

export type TaskAssignment = ReturnType<
  typeof getTaskAssignmentInfo
> extends Generator<unknown, infer R>
  ? R
  : never;

export function* getTaskAssignmentInfo() {
  const [assignedToId, dueDate]: [
    ReturnType<typeof getTaskAssignmentUserId>,
    ReturnType<typeof getTaskAssignmentDueDate>,
  ] = yield all([
    select(getTaskAssignmentUserId),
    select(getTaskAssignmentDueDate),
  ]);

  if (assignedToId) {
    return {
      assignedToId,
      dueDate: dueDate.toISOString(),
    };
  } else {
    return undefined;
  }
}

function* watchUpdateTask(
  action: ActionOfType<ChatTasksAction, typeof types.EDIT_TASK_REQUEST>,
) {
  try {
    const { assignedToId, dueDate, status, taskId } = action.payload;
    const response: ChatTask = yield call(
      partLibraryService.tasks.patch,
      taskId,
      {
        assignedToId,
        dueDate: dueDate ? dueDate.toISOString() : undefined,
        status,
      },
    );

    yield put(entitiesStore.receiveTask(response));
    yield put(editTask.success({ taskId }));
  } catch (error) {
    yield put(
      editTask.error(
        error,
        pathOr<number | null>(null, ['payload', 'taskId'], action),
      ),
    );
  }
}
